// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.super-pickem-leaderboard-button-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 95%;
  margin: 0 auto;
  gap: 40px;
  margin-top: 24px;
  margin-bottom: 12px;
}
@media screen and (max-width: 900px) {
  .super-pickem-leaderboard-button-container {
    gap: 20px;
  }
}

.super-pickem-leaderboard-button {
  width: 170px;
  height: 40px;
  white-space: nowrap;
  font-size: 20px !important;
  background-color: white !important; /* Ensure background stays white */
  border: 1px solid #9D9D9D !important; /* Ensure the border is always visible */
  color: #9D9D9D !important; /* Ensure text color stays #9D9D9D */
  cursor: pointer;
}
.super-pickem-leaderboard-button:hover {
  background-color: white !important; /* Force background to stay white on hover */
  color: #9D9D9D !important; /* Ensure text color stays #9D9D9D on hover */
  border: 1px solid #9D9D9D !important; /* Ensure border stays the same on hover */
}
.super-pickem-leaderboard-button.active {
  background-color: #E8E8E8 !important; /* Active state background */
  border: 1px solid #002129 !important; /* Active state border */
  color: #002129 !important; /* Active state text color */
}
@media (max-width: 900px) {
  .super-pickem-leaderboard-button {
    width: 108px;
    height: 33px;
    white-space: nowrap;
    font-size: 12px !important;
  }
}

.super-pickem-leaderboard-champ-image {
  display: block;
  width: 32px;
  height: 32px;
  margin: 0 auto;
  border-radius: 4px;
  object-fit: contain;
}

.super-pickem-leaderboard-champ-placeholder {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  margin: 0 auto;
  border-radius: 4px;
  background-color: transparent;
  border: 1px solid #002129;
}

.super-pickem-leader-no-champ {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  margin: 0 auto;
  border-radius: 4px;
  border: 1px solid #CC293C;
  background-color: rgba(204, 41, 60, 0.2);
}

.super-pickem-leaderboard-table {
  width: 670px;
  margin: 0 auto;
}
@media (min-width: 600px) {
  .super-pickem-leaderboard-table {
    width: 100% !important;
  }
}
@media (min-width: 960px) {
  .super-pickem-leaderboard-table {
    width: 100% !important;
  }
}
@media (min-width: 1200px) {
  .super-pickem-leaderboard-table {
    max-width: 1116px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SuperPickem/Leaderboard/SuperPickemLeaderboard.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AACJ;AACI;EAXJ;IAYQ,SAAA;EAEN;AACF;;AAEE;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,0BAAA;EACA,kCAAA,EAAA,kCAAA;EACA,oCAAA,EAAA,wCAAA;EACA,yBAAA,EAAA,oCAAA;EACA,eAAA;AACJ;AACI;EACE,kCAAA,EAAA,4CAAA;EACA,yBAAA,EAAA,6CAAA;EACA,oCAAA,EAAA,0CAAA;AACN;AAEI;EACE,oCAAA,EAAA,4BAAA;EACA,oCAAA,EAAA,wBAAA;EACA,yBAAA,EAAA,4BAAA;AAAN;AAGI;EAtBF;IAuBM,YAAA;IACA,YAAA;IACA,mBAAA;IACA,0BAAA;EAAN;AACF;;AAIE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AADJ;;AAIE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,6BAAA;EACA,yBAAA;AADJ;;AAIE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,wCAAA;AADJ;;AAIE;EACE,YAAA;EAcA,cAAA;AAdJ;AAEI;EAHF;IAIM,sBAAA;EACN;AACF;AACI;EAPF;IAQM,sBAAA;EAEN;AACF;AAAI;EAXF;IAYM,iBAAA;EAGN;AACF","sourcesContent":[".super-pickem-leaderboard-button-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    width: 95%;\n    margin: 0 auto;\n    gap: 40px;\n    margin-top: 24px;\n    margin-bottom: 12px;\n\n    @media screen and (max-width: 900px) {\n        gap: 20px;\n      \n    }\n  }\n  \n  .super-pickem-leaderboard-button {\n    width: 170px;\n    height: 40px;\n    white-space: nowrap;\n    font-size: 20px !important;\n    background-color: white !important; /* Ensure background stays white */\n    border: 1px solid #9D9D9D !important; /* Ensure the border is always visible */\n    color: #9D9D9D !important; /* Ensure text color stays #9D9D9D */\n    cursor: pointer;\n  \n    &:hover {\n      background-color: white !important; /* Force background to stay white on hover */\n      color: #9D9D9D !important; /* Ensure text color stays #9D9D9D on hover */\n      border: 1px solid #9D9D9D !important; /* Ensure border stays the same on hover */\n    }\n  \n    &.active {\n      background-color: #E8E8E8 !important; /* Active state background */\n      border: 1px solid #002129 !important; /* Active state border */\n      color: #002129 !important; /* Active state text color */\n    }\n\n    @media (max-width: 900px) {\n        width: 108px;\n        height: 33px;\n        white-space: nowrap;\n        font-size: 12px !important;\n    }\n  }\n\n\n  .super-pickem-leaderboard-champ-image {\n    display: block;\n    width: 32px;\n    height: 32px;\n    margin: 0 auto;\n    border-radius: 4px;\n    object-fit: contain;\n  }\n\n  .super-pickem-leaderboard-champ-placeholder {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 32px;\n    height: 32px;\n    margin: 0 auto;\n    border-radius: 4px;\n    background-color: transparent;\n    border: 1px solid #002129;\n  }\n\n  .super-pickem-leader-no-champ {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 32px;\n    height: 32px;\n    margin: 0 auto;\n    border-radius: 4px;\n    border: 1px solid #CC293C;\n    background-color: rgba(204, 41, 60, 0.2);\n  }\n  \n  .super-pickem-leaderboard-table {\n    width: 670px;\n\n    @media (min-width: 600px) {\n        width: 100% !important;\n    }\n\n    @media (min-width: 960px) {\n        width: 100% !important;\n    }\n\n    @media (min-width: 1200px) {\n        max-width: 1116px;\n    }\n\n    margin: 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
